"use client";

import type { Messages } from "next-intl";
import { NextIntlClientProvider } from "next-intl";
import { type PropsWithChildren, use } from "react";

import { merge } from "@/common/helpers/object";
import type { Locale } from "../models/locale";
import { MessagesContext } from "./messages-context";

interface MessagesProviderClientProps extends PropsWithChildren {
  messages: Partial<Messages>;
  locale: Locale;
  timeZone: string;
}

export function MessagesProviderClient({ children, messages, locale, timeZone }: MessagesProviderClientProps) {
  const finalMessages = merge(messages, use(MessagesContext));

  return (
    <MessagesContext value={finalMessages}>
      <NextIntlClientProvider messages={finalMessages} locale={locale} timeZone={timeZone}>
        {children}
      </NextIntlClientProvider>
    </MessagesContext>
  );
}
